var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38113 5.48277C8.78651 5.15211 9.38375 5.17575 9.76215 5.55369L15.6041 11.396C15.8 11.5919 15.906 11.8539 15.906 12.1256C15.906 12.3975 15.8002 12.659 15.6041 12.8556L9.76203 18.6977C9.35848 19.1008 8.70527 19.1008 8.30278 18.6977C7.89909 18.2945 7.89909 17.6411 8.30266 17.2381L13.4147 12.1256L8.30278 7.01328C7.92434 6.63529 7.90067 6.03745 8.23178 5.63202L8.30274 5.55362L8.38113 5.48277Z",
    fill: "#116E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevronRight.5aaf654c228daa74a426fa516ae2695c.svg";
export { ForwardRef as ReactComponent };